import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getSubHeaderLoans } from 'services/loans'

export default function useGetSubHeaderLoans(loan: number | undefined) {
    const [allData, setAllData] = useState<ISubHeaderLoan[]>([])
    const [page, setPage] = useState<number>(1)
    const [subHeaderData, setSubheaderData] = useState<
        ISubHeaderLoan | undefined
    >()
    const { moneyPool, poolship } = useParams()
    const { data, isLoading } = useQuery(
        ['sub-header-loans-page', moneyPool, poolship, page],
        getSubHeaderLoans
    )

    useEffect(() => {
        if (!data) return
        setAllData((prev) => [...prev, ...data.results])
        const alreadyFound = data.results.some((item) => item.id === loan)
        if (data.next && !alreadyFound) {
            setPage(page + 1)
        }
    }, [data])

    useEffect(() => {
        if (data && loan) {
            const result = allData.find((item) => item.id === loan)
            setSubheaderData(result)
        }
    }, [data, loan, allData])
    return { subHeaderData }
}
